import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getCodeRandom({ payload: { onSuccess } }) {

  try {
    const { data } = yield call(fetch, { api: api.codes.random });

    onSuccess && onSuccess(data.result);
    yield put(actions.getCodeRandomDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCodeRandomFailed,
      endpoint: api.codes.random.url
    });
  }
}

export const getCodeRandomSaga = takeEvery(types.GET_CODE_RANDOM_REQUEST, getCodeRandom);